"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgViewicsAppPackage = function SvgViewicsAppPackage(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("style", null, '.viewics_app_package_svg__st0{fill:none}.viewics_app_package_svg__st1{fill:#333}'), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "viewics_app_package_svg__Group_52467",
    transform: "translate(-48 -45)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "viewics_app_package_svg__Rectangle_13687"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50 45h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H50c-1.1 0-2-.9-2-2V47c0-1.1.9-2 2-2z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M64 63H50c-1.1 0-2-.9-2-2V47c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM50 47v14h14V47H50z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M58 50h4v4l-2-2-2 2v-4z",
    id: "viewics_app_package_svg__Path_38681"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59 58v-2h6v2h-6zm-4 0v-2h2v2h-2z",
    id: "viewics_app_package_svg__Union_336"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59 62v-2h6v2h-6zm-4 0v-2h2v2h-2z",
    id: "viewics_app_package_svg__Union_337"
  })));
};

var _default = SvgViewicsAppPackage;
exports["default"] = _default;